<template>
	<div v-loading="pageLoading">
		<el-form :model="formData" :rules="rules" ref="formData" label-position="top" size="medium">
			<div class="page-group-title"><span>基础信息</span></div>
			<el-form-item prop="title" label="模板名称">
				<el-input placeholder="请输入模板名称" v-model="formData.title" maxlength="30"></el-input>
				<template v-if="type == 1">
				<span>
					<el-checkbox v-model="formData.isKey" :true-label="1"
					:false-label="0">关键服务，勾选后乐迷端会以更显眼的形式展示该服务。</el-checkbox></span>
					<small><span class="color-danger">（不支持的服务需要重点告知用户的建议勾选，例如【不支持退票】【不支持转赠】）</span></small>
				</template>
			</el-form-item>
			<el-form-item label="业务分类:">
				<el-cascader v-model="formData.types" :options="typeOptions1" style="width: 100%;" v-if="type == 1 && (minitype == 1 || minitype ==2 || minitype == 3 )"></el-cascader>
				<!-- <div class="clearfix timeType" v-if="type == 1">
					<el-input class="input-with-select fl" size="small">
						<el-select v-model="formData.category" slot="prepend" placeholder="请选择">
							<el-option label="服务说明" :value="1"></el-option>
							<el-option label="购票须知" :value="2"></el-option>
							<el-option label="观演须知" :value="3"></el-option>
						</el-select>
					</el-input>
					<el-select v-model="formData.type" placeholder="请选择二级分类" class="fl fl-big-select"
						clearable size="small">
						<el-option v-for="(item, index) in typeList" :label="item.label" :key="index"
							:value="item.value" ></el-option>
					</el-select>
				</div> -->
				<el-cascader v-model="formData.types" :options="typeOptions2" style="width: 100%;"
					v-if="type == 2 && minitype == 4"></el-cascader>
				<el-cascader v-model="formData.types" :options="typeOptions3" style="width: 100%;"
					v-if="type == 3 && minitype == 5"></el-cascader>
			</el-form-item>
			<el-form-item label="绑定对象ID:" v-if="type == 1 || type == 3 ">
				<!-- <span slot="label"><el-checkbox v-model="joinType1" @change="joinTypeFun1">绑定对象ID：</el-checkbox></span> -->
				<el-input placeholder="输入演出ID，多个ID用逗号分隔" v-model="sActivityIds">
					<el-button slot="append" icon="el-icon-search" @click="searchActivity()">添加演出</el-button>
				</el-input>
				<el-table class="MT10" :data="sActivityList" size="mini" border stripe
					v-loading="sActivityLoading">
					<el-table-column prop="id" label="演出ID" width="90"></el-table-column>
					<el-table-column prop="name" label="演出名称" show-overflow-tooltip></el-table-column>
					<el-table-column label="操作" width="80">
						<template slot-scope="scope">
							<el-button type="text" @click="delActivity(scope.row.id)">删除</el-button>
						</template>
					</el-table-column>
				</el-table>
				<small><span class="color-warning">绑定对象为空视为通用模板，否则请填写绑定的业务对象ID （演出ID）</span></small>
			</el-form-item>
			<el-form-item label="绑定对象ID:" v-if="type == 2 ">
				<el-input placeholder="输入周边ID，多个ID用逗号分隔" v-model="sgoodsIds">
					<el-button slot="append" icon="el-icon-search" @click="searchGoods()">添加商品</el-button>
				</el-input>
				<el-table class="MT10" :data="sgoodsList" size="mini" border stripe v-loading="sGoodsLoading">
					<el-table-column prop="id" label="商品ID" width="90"></el-table-column>
					<el-table-column prop="name" label="商品名称" show-overflow-tooltip></el-table-column>
					<el-table-column label="操作" width="80">
						<template slot-scope="scope">
							<el-button type="text" @click="delGoods(scope.row.id)">删除</el-button>
						</template>
					</el-table-column>
				</el-table>
				<small><span class="color-warning">绑定对象为空视为通用模板，否则请填写绑定的业务对象ID （周边ID）</span></small>
			</el-form-item>
			
			<div class="page-group-title"><span>条款信息</span></div>
			<el-form-item prop="chineseContent" label="中文内容">
				<el-input v-model="formData.chineseContent" type="textarea" :rows="10"></el-input>
				<!-- <tinymce v-model="formData.chineseContent" :toolbar="toolbar" :menubar="false" v-if="reFresh"></tinymce> -->
			</el-form-item>
			<el-form-item prop="englishContent" label="英文内容">
				<!-- <tinymce v-model="formData.englishContent" :toolbar="toolbar" :menubar="false" v-if="reFresh"></tinymce> -->
				<el-input v-model="formData.englishContent" type="textarea" :rows="10"></el-input>
			</el-form-item>

			<el-form-item>
				<el-button @click="goBack">返回取消</el-button>
				<el-button type="primary" @click="onSubmit" :loading="btnLoading">确认提交</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
	// import Tinymce from '@/components/Tinymce'; 
	import {
		fetchServiceTemplateType
	} from '@/assets/js/commonApi'
	export default {
		props: {
			id: {
				type: [Number, String],
				default: null,
			},
			type: {
				type: [Number, String],
				default: null,
			},
			minitype: {
				type: [Number, String],
				default: null,
			},
		},
		// components:{Tinymce},
		data() {
			return {
				formData: {
					title: "",
					businessType: "",
					type: '',
					chineseContent: '',
					englishContent: '',
					types: [],
					category: 1,

				},
				rules: {
					title: [{
						required: true,
						message: "请输入服务模板名称"
					}],
					types: [{
						required: true,
						message: "请选择业务分类"
					}],
					chineseContent: [{
						required: true,
						message: "请输入中文条款"
					}],
					englishContent: [{
						required: true,
						message: "请输入英文条款"
					}]
				},
				btnLoading: false,
				pageLoading: false,
				redirect: this.$route.query.redirect || "/system/serviceTemplate/list",
				reFresh: false,
				v: this.$route.query.v || '',
				// toolbar:['formatselect fontsizeselect | forecolor bold strikethrough | alignleft aligncenter alignright alignjustify | preview fullscreen'],
				// typeList: [],

				typeOptions1: [],
				typeOptions2: [],
				typeOptions3: [],

				joinType1: '',
				joinType2: '',
				joinType3: '',
				sActivityIds: "",
				sActivityLoading: false,
				sActivityList: [],

				sgoodsList: [],
				sgoodsIds: "",
				sGoodsLoading: false,
				typeList: [],
				terminal: [{
					label: 'APP',
					value: 'app'
				}, {
					label: 'WAPCN',
					value: 'wap'
				}, {
					label: 'WEB',
					value: 'web'
				}, {
					label: '微信小程序',
					value: 'wechat_mini'
				}, {
					label: '抖音小程序',
					value: 'byte_mini'
				}, {
					label: '支付宝小程序',
					value: 'ali_mini'
				}]

			};
		},
		created() {

			if (this.id) {
				this.getData();
			} else {
				this.reFresh = true;
			}
			// const _typeList = fetchServiceTemplateType();
			// this.typeList = _typeList.filter((item) => item.value != 0);
		},
		mounted() {

			const _typeList = fetchServiceTemplateType();
			const _orther = _typeList.filter((item) => item.value === 3);
			const _Activity1 = _typeList.filter((item) => item.value == 1);
			const _Activity2 = _typeList.filter((item) => item.value == 3 || item.value == 4 || item.value == 9);
			const _Activity3 = _typeList.filter((item) => item.value == 6 || item.value == 7 );
			
			
			if( this.type == 1 && this.minitype == 1 ){
				this.typeOptions1 = [
					{ label: "服务说明", value: 1 , children: [..._Activity1 ]},
					
				]
			}
			if( this.type == 1 && this.minitype == 2 ){
				this.typeOptions1 = [
					{ label: "购票须知", value: 2 , children: [..._Activity2 ]},
					
				]
			}
			if( this.type == 1 && this.minitype == 3 ){
				this.typeOptions1 = [
					{ label: "观演须知", value: 3 , children: [..._Activity3 ]},
					
				]
			}
			
			this.typeOptions2 = [		    
			    { label: "周边", value: 2, children: [..._orther]}
			]
			this.typeOptions3 = [		   
			    { label: "其它", value: 3, children: [..._orther]}
			]

		},
		methods: {

			// 获取详情
			getData() {
				this.pageLoading = true;
				this.$request({
					url: "/service/template/detail",
					method: "POST",
					params: {
						id: this.id
					},
				}).then((res) => {
					//处理成功回调
					const {
						state,
						msg,
						result
					} = res.data;
					if (state && state == 1 && result) {
						this.formData = {
							...result,
							types: [parseInt(this.minitype), result.type]
						}
						this.reFresh = true;
						
						if (this.formData.bindIds && (this.type == 1 || this.type == 3)) {
							let _sActivityIds = [];
							if (this.formData.bindIds) {
								const _ids = this.formData.bindIds.split(',');
								_sActivityIds = _sActivityIds.concat(_ids);
							}
							this.sActivityIds = _sActivityIds.toString();
							if (this.sActivityIds) {
								this.searchActivity(() => {
									this.$nextTick(() => {
										const _ticketIds = this.formData.ticketIds.split(',') ||
									[];
										this.sActivityList.map(item => {
											item.sessions.map(s => {
												_ticketIds.map(t => {
													if (s.tickets.find(
															t1 => t1.id ==
															t)) {
														if (item.ids) {
															item.ids.push(
																t);
														} else {
															item.ids = [t]
														}
													}
												})
											})
										})
									})
								});
							}
						}
						if (this.formData.bindIds && this.type == 2) {
							let _sgoodsIds = [];
							if (this.formData.bindIds) {
								const _ids = this.formData.bindIds.split(',');
								_sgoodsIds = _sgoodsIds.concat(_ids);
							}
							this.sgoodsIds = _sgoodsIds.toString();
							if (this.sgoodsIds) {
								this.searchGoods(() => {
									this.$nextTick(() => {
										const _ticketIds = this.formData.ticketIds.split(',') ||
									[];
										this.sgoodsList.map(item => {
											item.sessions.map(s => {
												_ticketIds.map(t => {
													if (s.tickets.find(
															t1 => t1.id ==
															t)) {
														if (item.ids) {
															item.ids.push(
																t);
														} else {
															item.ids = [t]
														}
													}
												})
											})
										})
									})
								});
							}
							this.searchGoods();
						}
					} else {
						return this.$message.error(msg || "获取详情失败");
					}
				}).finally(() => {
					this.pageLoading = false;
				});
			},
			//搜索演出
			searchActivity() {

				if (this.sActivityIds) {
					this.sActivityLoading = true;

					this.sActivityIds = this.sActivityIds.replace(/，/g, ',');

					let _sActivityIds = this.sActivityIds.split(',');
					_sActivityIds.map((v, i) => _sActivityIds[i] = parseInt(v));


					this.$request({
							url: "/activity/activityIdNameList",
							method: 'post',
							data: _sActivityIds
						})
						.then((res) => {
							const {
								state,
								msg,
								result
							} = res.data;
							if (result && result.length > 0) {
								this.sActivityLoading = false;
								result.map(item => {
									if (!this.sActivityList.find(v => v.id == item.id)) {
										this.sActivityList.push(item)
									}
								})

							} else {
								this.sActivityLoading = false;
								this.$message.error(msg || '没有找到相关演出');
							}
						})

				}
			},
			//删除演出
			delActivity(id) {
				this.sActivityList = this.sActivityList.filter(v => v.id != id);
			},
			//搜索商品
			searchGoods() {

				if (this.sgoodsIds) {
					this.sGoodsLoading = true;
					this.sgoodsIds = this.sgoodsIds.replace(/，/g, ',');
					let _sgoodsIds = this.sgoodsIds.split(',');
					_sgoodsIds.map((v, i) => _sgoodsIds[i] = parseInt(v));

					this.$request({
							url: "/shop_good/goodsIdNameList",
							method: 'post',
							data: _sgoodsIds
						})
						.then((res) => {
							const {
								state,
								msg,
								result
							} = res.data;
							if (result && result.length > 0) {
								this.sGoodsLoading = false;
								result.map(item => {
									if (!this.sgoodsList.find(v => v.id == item.id)) {
										this.sgoodsList.push(item)
									}
								})

							} else {
								this.sGoodsLoading = false;
								this.$message.error(msg || '没有找到相关周边');
							}
						})
				}
			},
			//删除演出
			delGoods(id) {
				this.sgoodsList = this.sgoodsList.filter(v => v.id != id);
			},
			//表单提交
			onSubmit() {
				let _activityIds = [];
				let _goodsIds = []
				this.sActivityList.map(item => {
					if (!item.ids || item.ids.length < 1) {
						_activityIds.push(item.id);
					}
				})
				this.sgoodsList.map(item => {
					if (!item.ids || item.ids.length < 1) {
						_goodsIds.push(item.id);
					}
				})
				this.formData.bindIds = this.type == 1 || this.type == 3 ? _activityIds : _goodsIds
				this.formData.category = this.type == 1 ? this.formData.types[0] : 0
				
				this.$refs["formData"].validate((valid) => {
					if (valid) {
						this.btnLoading = true;
						this.$request({
								url: !this.id ? "/service/template/create" : "/service/template/update",
								method: "POST",
								data: {
									...this.formData,
									businessType: this.type,
									type: this.formData.types[1],
									bindIds: this.formData.bindIds.toString()
								},
							})
							.then((res) => {
								//处理成功回调
								const {
									state,
									msg
								} = res.data;
								if (state && state == 1) {
									this.goBack();
								} else {
									return this.$message.error(msg || "操作失败");
								}
							})
							.finally(() => {
								this.btnLoading = false;
							});
					}
				});
			},
			//返回
			goBack() {
				this.$router.push({
					path: this.redirect,
				});
			},
		},
	};
</script>
<style lang="scss" scoped>
	::v-deep .timeType {
		.input-with-select {
			width: 154px;
			position: relative;
			.el-select {
				.el-input {
					min-width: 154px;
				}
			}
		}

		.el-date-editor,
		.fl-big-select {
			width: calc(100% - 156px) !important;
			margin-left: -32px;
			border-radius: 0 4px 4px 0;
			margin-top: -3px;
		}

		.fl-big-select {
			input {
				border-radius: 0 4px 4px 0;
			}
		}
	}
</style>